export default __webpack_public_path__ + "static/media/cp_geo_hr.e598c787.svg";